import React, { useEffect } from "react"

const AstonMartinAds = () => {
  useEffect(() => {
    const script = document.createElement("script")
    script.id = "astonMartinScript"
    script.type = "text/javascript"
    script.src = "https://epnt.ebay.com/static/epn-smart-tools.js"
    script.async = true
    document.getElementById("astonMartinScript").appendChild(script)
  }, [])

  return (
    <>
      <div id="astonMartinScript" />
      <div className="ebayContainer">
        <div className="ebay">
          <ins
            className="epn-placement"
            data-config-id="5efca4bb33062f08c1484c2d"
            data-keyword="aston martin vantage"
          ></ins>
        </div>
      </div>
    </>
  )
}

export default AstonMartinAds 